import IssueOwnershipCertificateExternal from './IssueOwnershipCertificateExternal'

export default IssueOwnershipCertificateExternal
